/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import {Skeleton} from "@mui/material";
import classes from "@/app/components/NoRoute/404-styles.module.scss";

const NoRouteSkeleton = (props:any) => {
    return <>
        <Skeleton className={`${classes['content-skeleton']}`} />
    </>
}

export default NoRouteSkeleton;